import React from 'react';
import { render } from 'react-dom';
import { Toaster } from './components/Toaster';
import { ExtensionProvider } from './components/ExtensionProvider.component';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { ReactRouterHistory } from './utils/router';

document.addEventListener('DOMContentLoaded', function () {
    const el = document.getElementById('react-toasts');
    if (el) {
        render(
            <ExtensionProvider layout={J.reactLayout}>
                <HistoryRouter history={ReactRouterHistory as any}>
                    <Toaster />
                </HistoryRouter>
            </ExtensionProvider>,
            el,
        );
    }
});
